<div class="not-found">
  <app-missing-ufo></app-missing-ufo>
  <h4>{{ "Error.404Message" | translate }}</h4>
  <button class="back-btn"><mat-icon>arrow_backward</mat-icon>{{ "Common.Back" | translate }}</button>
</div>
